import { inject, Injectable } from '@angular/core';

// import { PlatformStore } from '@core/stores/platform.store';
// import { UbigeoStore } from '@core/stores/ubigeo.store';
import { UserStore } from '@core/stores/user.store';

@Injectable({ providedIn: 'root' })
export class AppStateService {
  private readonly userStore = inject(UserStore);
  // private readonly platformStore = inject(PlatformStore);
  // private readonly ubigeoStore = inject(UbigeoStore);

  clear(): void {
    this.userStore.reset();
    // this.platformStore.reset();
    // this.ubigeoStore.reset();
  }

  loadInitialState(): void {
    this.userStore.loadUser();
    // this.platformStore.loadPlatforms();
    // this.ubigeoStore.loadUbigeos();
  }
}
